import React from 'react';
import bgImage from '../../assets/aboutPage/top-about-bg.jpg';
import './pagesHeroSection.scss';

const PagesHeroSection = ({ page, background }) => {
  return (
    <section
      className="pages-hero"
      style={{
        backgroundImage: `url(${background || bgImage})`,
      }}
    >
      <div className="overlay">
        <h1>{page}</h1>
        <div className="divider"></div>
      </div>
    </section>
  );
};

export default PagesHeroSection;
